

import { useQuery } from "@tanstack/react-query";
import { getUsers } from "../api";

export function useUserManagementHook({ token, enabled = true }) {
  return useQuery({
    queryKey: ["users"],
    enabled: enabled && !!token,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    queryFn: async () => {
      const result = await getUsers({ token });
      if (!result.ok) {
        throw new Error(result.error || "Unable to load users.");
      }
      return result.users ?? [];
    },
  });
}